<ng-container *transloco="let t">
  <section class="wrapper alt">
    <div class="inner">
      <h2 class="major">{{ t('myBlogPosts') }}</h2>
      <input
        type="text"
        [attr.placeholder]="'search' | transloco"
        name="demo-name"
        aria-required="false"
        [attr.aria-label]="'searchAriaLabel' | transloco"
        #input
      />

      <div *ngIf="keyword$ | async as keyword" class="active-keyword-filter">
        <h3>{{ t('filter') }}:</h3>
        <button
          class="button xs"
          [title]="'keywordRemove' | transloco: { value: keyword }"
          (click)="removeKeywordFilter()"
        >
          {{ keyword }}
          <i class="fa fa-close"></i>
        </button>
      </div>
      <dk-preview
        content="blog"
        [keyword]="keyword$ | async"
        [search]="searchString"
      ></dk-preview>
    </div>
  </section>
</ng-container>
